define('SageDotCom/DataLayer/Events/carouselGeneric',['jquery', 'SageDotCom/DataLayer/Events/eventBase'], function ($, EventBase) {

    function GenericCarousel() {
        EventBase.call(this); // inherit eventBase
        this.name = 'carousel_int'; // overwrite name
    }

    GenericCarousel.prototype = Object.create(EventBase.prototype);

    GenericCarousel.prototype.GenerateEventMetadata = function GenerateEventMetadata(scope, label, menu) {
        // generate event object based on data from the component
        var lbl = label || $(scope).attr('data-title') || $(scope).text() || $('a:first', scope).text() || '(not set)';
        lbl = this.cleanseString(lbl);
        menu = this.cleanseString(menu);
        var id = this.getId(scope);
        var location = this.getLocation(scope);

        // business_select schema defined in tealium
        var eventObj = {
            'event_name': this.name,
            'event_non-int': '0',
            'event_category': 'component',
            'event_action': this.name,
            'event_label': lbl,
            'event_name_level_1': id,
            'event_name_level_2': lbl,
            'event_name_level_3': menu || '(not set)',
            'event_name_level_4': location
        };

        return eventObj;
    }

    return new GenericCarousel();
});
